export default "__VITE_ASSET__B4kM9gJp__"